module.exports = __webpack_public_path__ + "static/img/question-red.b26ce107.svg";